var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-block"},[_c('div',{staticClass:"link-block-value"},[_c('AvatarIcon',{attrs:{"icon":_vm.icon}})],1),_c('TitleSection',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }